(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5948],{

/***/ 35035:
/***/ (function(module) {

"use strict";


module.exports = function (data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);

        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for (i = 0; i < node.length; i++) {
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (node === null) return 'null';

        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }

        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify(node[key]);

            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    })(data);
};


/***/ }),

/***/ 40570:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutii-finantare/credit-online",
      function () {
        return __webpack_require__(98234);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./lib/structuredData.js
var structuredData = __webpack_require__(89229);
;// CONCATENATED MODULE: ./components/BreadcrumbSchema.js




var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, baseUrl = _publicRuntimeConfig.settings.baseUrl;
var BreadcrumbSchema = function(param) {
    var breadcrumbData = param.breadcrumbData, currentPath = param.currentPath;
    // Do not include home page
    // Do not include pages without parent
    if (breadcrumbData && breadcrumbData.length > 1) {
        var itemListElement = breadcrumbData.map(function(breadcrumb, index) {
            return {
                "@type": "ListItem",
                position: index + 1,
                name: breadcrumb.name,
                item: breadcrumb.level != 99 ? "".concat(baseUrl, "/").concat(breadcrumb.url_key).concat(breadcrumb.url_suffix || "") : "".concat(baseUrl).concat(currentPath)
            };
        });
        var schema = {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: itemListElement
        };
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: (0,structuredData/* default */.Z)(schema)
            }
        }));
    }
    return null;
};
/* harmony default export */ var components_BreadcrumbSchema = (BreadcrumbSchema);

;// CONCATENATED MODULE: ./components/Breadcrumbs.js








var Breadcrumbs_ref = (0,config["default"])(), settings = Breadcrumbs_ref.publicRuntimeConfig.settings;
var isBricoStore = settings.websiteName === "bricostore";
var Breadcrumbs = function(param) {
    var breadcrumbs = param.breadcrumbs, _isPDP = param.isPDP, isPDP = _isPDP === void 0 ? false : _isPDP, className = param.className;
    var router = (0,next_router.useRouter)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            breadcrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BreadcrumbSchema, {
                breadcrumbData: breadcrumbs,
                currentPath: router.asPath
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "Breadcrumbs is-hidden-in-mobile-app pb-3 lg:py-3 truncate text-sm ".concat(className),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                    className: "p-0 m-0 list-none inline",
                    children: breadcrumbs.map(function(breadcrumb, index) {
                        return breadcrumb.level != 99 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: classnames_default()("inline", {
                                "text-red-brand": isBricoStore || !isPDP,
                                "text-[#1D4ED8]": !isBricoStore && isPDP
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "".concat(settings.baseUrl, "/").concat(breadcrumb.url_key).concat(breadcrumb.url_suffix || ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        title: breadcrumb.name,
                                        className: classnames_default()({
                                        }),
                                        children: breadcrumb.name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mx-1",
                                    children: "/"
                                })
                            ]
                        }, "".concat(breadcrumb.level, "-").concat(breadcrumb.id, "-").concat(index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "inline",
                            children: breadcrumb.name
                        }, "".concat(breadcrumb.level, "-").concat(breadcrumb.id, "-").concat(index));
                    })
                })
            })
        ]
    }));
};
Breadcrumbs.propTypes = {
    breadcrumbs: prop_types_default().arrayOf(prop_types_default().shape({
        id: (prop_types_default()).number.isRequired,
        level: (prop_types_default()).number.isRequired,
        name: (prop_types_default()).string.isRequired,
        url_key: function(props, propName) {
            if (props["level"] !== 99 && (typeof props[propName] !== "string" || props[propName].length === 0)) {
                return new Error("Please provide url_key when item level is not 99.");
            }
        },
        url_suffix: (prop_types_default()).string
    })).isRequired
};
/* harmony default export */ var components_Breadcrumbs = (Breadcrumbs);


/***/ }),

/***/ 71662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var InputCheckbox = function(props) {
    var input = props.input, _meta = props.meta, touched = _meta.touched, error = _meta.error, visited = _meta.visited;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: "flex ".concat(props.className ? props.className : "", " ").concat(props.disabled ? "disabled" : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({}, input, {
                        type: "checkbox",
                        required: props.required,
                        disabled: props.disabled,
                        className: "checkbox-input opacity-0 w-0 h-0 ".concat(touched && error ? "error" : "")
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "checkbox-control flex-none w-5 h-5 p-1 mr-2 border-gray-light border rounded-4px bg-white ".concat(props.required ? "is-required" : ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                            className: "",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            "aria-hidden": "true",
                            focusable: "false",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "3",
                                d: "M1.73 12.91l6.37 6.37L22.79 4.59"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "block Form-label label ".concat(props.spanClassName, " ").concat(props.required ? "is-required" : ""),
                        children: typeof props.label === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: props.label
                            }
                        }) : props.label
                    })
                ]
            }),
            props.required && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: visited && error ? "" : "hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-red-brand text-sm",
                    children: error
                })
            })
        ]
    }));
};
InputCheckbox.defaultProps = {
    required: undefined,
    disabled: undefined
};
/* harmony default export */ __webpack_exports__["Z"] = (InputCheckbox);


/***/ }),

/***/ 97119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11752);



var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_2__["default"])(), settings = ref.publicRuntimeConfig.settings;
var ResponsiveHeroBanner = function(param) {
    var banner = param.banner;
    var ref12, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var desktopImage = (ref12 = banner.images) === null || ref12 === void 0 ? void 0 : (ref1 = ref12[0]) === null || ref1 === void 0 ? void 0 : ref1.file;
    var tabletImage = (ref2 = banner.images_tablet) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.file;
    var mobileImage = (ref4 = banner.images_mobile) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.file;
    var link = ((ref6 = banner.images) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.link) || ((ref8 = banner.images_mobile) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.link) || ((ref10 = banner.images_tablet) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : ref11.link);
    var hasImage = desktopImage || tabletImage || mobileImage;
    if (!hasImage) {
        return null;
    }
    if (link) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
            href: link,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                title: "",
                children: [
                    mobileImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "".concat(settings.cdn).concat(mobileImage),
                        className: "w-full sm:hidden",
                        alt: ""
                    }),
                    tabletImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "".concat(settings.cdn).concat(tabletImage),
                        className: "w-full hidden sm:block lg:hidden rounded-tr-lg rounded-bl-lg",
                        alt: ""
                    }),
                    desktopImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "".concat(settings.cdn).concat(desktopImage),
                        className: "w-full hidden lg:block rounded-tr-lg rounded-bl-lg",
                        alt: ""
                    })
                ]
            })
        }));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            mobileImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "".concat(settings.cdn).concat(mobileImage),
                className: "w-full sm:hidden",
                alt: ""
            }),
            tabletImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "".concat(settings.cdn).concat(tabletImage),
                className: "w-full hidden sm:block lg:hidden rounded-tr-lg rounded-bl-lg",
                alt: ""
            }),
            desktopImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "".concat(settings.cdn).concat(desktopImage),
                className: "w-full hidden lg:block rounded-tr-lg rounded-bl-lg",
                alt: ""
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ResponsiveHeroBanner);


/***/ }),

/***/ 89229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35035);
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0__);

// JSON-LD blocks are injected with dangerouslySetInnerHTML, so a "<" coming
// from product data (a "</script>" inside a product name or description) would
// close the script element early and make the whole block unparsable for
// crawlers, besides letting the markup run in the browser. These characters
// are only ever part of JSON string values, where the escaped form is
// equivalent, so escaping them keeps the JSON valid and the page safe.
var HTML_UNSAFE_ESCAPES = {
    "<": "\\u003c",
    ">": "\\u003e",
    "&": "\\u0026"
};
var serializeSchema = function(schema) {
    return fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0___default()(schema).replace(/[<>&]/g, function(character) {
        return HTML_UNSAFE_ESCAPES[character];
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (serializeSchema);


/***/ }),

/***/ 6100:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var transformV2Banners = function(banners) {
    var basePath = "/media";
    var getImageObject = function(filePath, link) {
        return {
            link: link || "/",
            file: basePath + filePath
        };
    };
    var result = {
        id: banners.id || "",
        name: banners.name || "",
        position: banners.position || "",
        images: [],
        images_mobile: [],
        images_tablet: []
    };
    banners.images.forEach(function(item) {
        if (item.file) {
            result.images.push(getImageObject(item.file, item.url));
        }
        if (item.file_mobile) {
            result.images_mobile.push(getImageObject(item.file_mobile, item.url));
        }
        if (item.file_tablet) {
            result.images_tablet.push(getImageObject(item.file_tablet, item.url));
        }
    });
    return result;
};
/* harmony default export */ __webpack_exports__["Z"] = (transformV2Banners);


/***/ }),

/***/ 98234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ credit_online; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./store/financing-solutions/actions.js + 1 modules
var actions = __webpack_require__(82518);
// EXTERNAL MODULE: ./store/credex/actions.js
var credex_actions = __webpack_require__(92143);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(65988);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./components/Breadcrumbs.js + 1 modules
var Breadcrumbs = __webpack_require__(94512);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./components/Form/InputText.js + 2 modules
var InputText = __webpack_require__(58833);
// EXTERNAL MODULE: ./components/Form/Checkbox.js
var Checkbox = __webpack_require__(71662);
// EXTERNAL MODULE: ./components/Form/Select.js
var Select = __webpack_require__(66569);
// EXTERNAL MODULE: ./components/Loading.js
var Loading = __webpack_require__(24461);
// EXTERNAL MODULE: ./lib/validations.js + 1 modules
var validations = __webpack_require__(38294);
// EXTERNAL MODULE: ./components/Heading.js
var Heading = __webpack_require__(73510);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(52077);
// EXTERNAL MODULE: ./components/Alert.js + 10 modules
var Alert = __webpack_require__(16479);
;// CONCATENATED MODULE: ./components/FinancingSolutions/OnlineCreditRequestForm.js
















function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, credex = _publicRuntimeConfig.credex, _settings = _publicRuntimeConfig.settings, currency = _settings.currency, baseUrl = _settings.baseUrl, websiteName = _settings.websiteName;
var OnlineCreditRequestForm = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(OnlineCreditRequestForm, Component1);
    var _super = _createSuper(OnlineCreditRequestForm);
    function OnlineCreditRequestForm(props) {
        _classCallCheck(this, OnlineCreditRequestForm);
        var _this;
        _this = _super.call(this, props);
        var _this1 = _assertThisInitialized(_this);
        _defineProperty(_assertThisInitialized(_this), "getLoanSimulation", _asyncToGenerator(runtime_default().mark(function _callee() {
            var amount, installmentsNumber, loanSimulation, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        amount = _args.length > 0 && _args[0] !== void 0 ? _args[0] : credex.calculator.defaultAmount, installmentsNumber = _args.length > 1 && _args[1] !== void 0 ? _args[1] : null;
                        _ctx.next = 3;
                        return _this1.props.getLoanSimulation({
                            amount: amount,
                            method: [
                                "credex"
                            ]
                        });
                    case 3:
                        loanSimulation = _ctx.sent;
                        if (loanSimulation && !loanSimulation.error) {
                            if (loanSimulation.data.credex && Array.isArray(loanSimulation.data.credex) && loanSimulation.data.credex.length !== 0) {
                                _this1.setState({
                                    installments: installmentsNumber || loanSimulation.data.credex[0].installment_no,
                                    amount: amount,
                                    credexLoanSimulation: loanSimulation.data.credex,
                                    rate: installmentsNumber ? loanSimulation.data.credex.find(function(param) {
                                        var installment_no = param.installment_no;
                                        return installment_no == installmentsNumber;
                                    }).installment_value : loanSimulation.data.credex[0].installment_value
                                });
                            } else {
                                _this1.setState({
                                    rate: 0
                                });
                            }
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })));
        _defineProperty(_assertThisInitialized(_this), "updateFormState", debounce_default()(function(subscription) {
            var errors = subscription.errors, values = subscription.values, active = subscription.active;
            if (active && _this.state.isSent) {
                _this.setState({
                    isSent: false
                });
            }
            // Set amount and installments number
            // if we don't have validation errors on these fields
            var amount = !errors.amount ? values.amount : null;
            var installmentsNumber = !errors.installments ? values.installments : null;
            if (amount && _this.state.amount != amount || installmentsNumber && installmentsNumber != _this.state.installments) _this.getLoanSimulation(Number(amount), Number(installmentsNumber));
        }, 500));
        var _this2 = _assertThisInitialized(_this);
        _defineProperty(_assertThisInitialized(_this), "handleFormSubmit", function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee(values) {
                var customer, response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            customer = _this2.props.customer;
                            _this2.setState({
                                isSent: false,
                                isSending: true
                            });
                            _ctx.next = 4;
                            return _this2.props.onFormSubmit({
                                firstname: values.first_name,
                                lastname: values.last_name,
                                email: values.email,
                                phone: values.phone,
                                amount: values.amount,
                                rates: values.installments
                            });
                        case 4:
                            response = _ctx.sent;
                            if (response) {
                                _this2.setState({
                                    isSent: true,
                                    isSending: false,
                                    rate: undefined,
                                    amount: credex.calculator.defaultAmount
                                });
                                _this2.formReset({
                                    first_name: customer && customer.first_name,
                                    last_name: customer && customer.last_name,
                                    email: customer && customer.email,
                                    phone: customer && customer.telephone,
                                    amount: credex.calculator.defaultAmount,
                                    installments: _this2.state.credexLoanSimulation[0],
                                    agree_terms: false
                                });
                            } else {
                                _this2.setState({
                                    isSent: false,
                                    isSending: false
                                });
                            }
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }());
        _this.state = {
            rate: undefined,
            isSent: false,
            isSending: false,
            installments: null,
            credexLoanSimulation: null,
            amount: credex.calculator.defaultAmount
        };
        _this.formReset = undefined;
        return _this;
    }
    _createClass(OnlineCreditRequestForm, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return _asyncToGenerator(runtime_default().mark(function _callee() {
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _this.getLoanSimulation(_this.state.amount, null);
                            case 1:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "render",
            value: function render() {
                var customer = this.props.customer;
                var _state = this.state, rate = _state.rate, isSent = _state.isSent, isSending = _state.isSending, credexLoanSimulation = _state.credexLoanSimulation, installments = _state.installments, amount = _state.amount;
                // Show calculator if we have data
                if (credex.calculator.defaultAmount && credex.calculator.minAmount && credex.calculator.maxAmount) {
                    var _this = this;
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                as: "h2",
                                display: "h2",
                                title: "Calculator rate",
                                classesProp: "mb-3 lg:mb-1 -tracking-0.5 lg:-tracking-0.67"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mb-5 sm:mb-15px text-sm leading-20 -tracking-0.29 lg:text-base lg:leading-22 lg:-tracking-0.39",
                                children: "Completeaza valoarea produselor, selecteaza numarul de rate dorit si afla rata lunara:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
                                onSubmit: function(values) {
                                    return _this.handleFormSubmit(values);
                                },
                                initialValues: {
                                    first_name: customer && customer.first_name,
                                    last_name: customer && customer.last_name,
                                    email: customer && customer.email,
                                    phone: customer && customer.telephone,
                                    amount: amount,
                                    installments: installments
                                },
                                render: function(param) {
                                    var handleSubmit = param.handleSubmit, form = param.form;
                                    _this.formReset = form.reset;
                                    var tipMessage = credexLoanSimulation === null || credexLoanSimulation === void 0 ? void 0 : credexLoanSimulation.find(function(loanSimulation) {
                                        return Boolean(loanSimulation.additional_data);
                                    });
                                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                        onSubmit: handleSubmit,
                                        noValidate: true,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* FormSpy */.lP, {
                                                onChange: _this.updateFormState,
                                                subscription: {
                                                    active: true,
                                                    values: true,
                                                    errors: true
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "xl:flex xl:-mx-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "xl:w-1/2 xl:px-2 mb-4 xl:mb-0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                            component: InputText/* default */.Z,
                                                            id: "online_credit_request_amount",
                                                            name: "amount",
                                                            label: "Valoarea totala a produselor",
                                                            inputClassName: "max-w-full",
                                                            labelClass: "leading-18.2",
                                                            type: "text",
                                                            validateOn: "active",
                                                            required: true,
                                                            validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isNumber */.hj)(), (0,validations/* isInRange */.mh)(credex.calculator.minAmount, credex.calculator.maxAmount, "Oferta valabila de la ".concat(credex.calculator.minAmount, " ").concat(currency, " la ").concat(credex.calculator.maxAmount, " ").concat(currency)))
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "xl:w-1/2 xl:px-2 mb-4 xl:mb-0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                            id: "online_credit_request_installments",
                                                            name: "installments",
                                                            component: Select/* default */.Z,
                                                            label: "Numar de rate",
                                                            inputClassName: "max-w-full",
                                                            labelClass: "leading-18.2",
                                                            // If installments array contains
                                                            // only one installment disable select
                                                            disabled: (credexLoanSimulation === null || credexLoanSimulation === void 0 ? void 0 : credexLoanSimulation.length) === 1,
                                                            children: credexLoanSimulation === null || credexLoanSimulation === void 0 ? void 0 : credexLoanSimulation.map(function(month) {
                                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                                                    value: month.installment_no,
                                                                    children: month.installment_no
                                                                }, month.installment_no);
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            tipMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "flex items-center justify-start bg-yellow-300 shadow-inner rounded-md w-full mt-5 px-4 py-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "inline-block",
                                                    children: [
                                                        tipMessage.additional_data.message.split("{{value}}")[0],
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: tipMessage.additional_data.value
                                                        }),
                                                        tipMessage.additional_data.message.split("{{value}}")[1]
                                                    ]
                                                })
                                            }),
                                            !isNaN(rate) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mt-3 mb-6 pb-6 lg:pb-8 lg:mb-8 border-b text-center lg:mt-6",
                                                children: rate > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                            as: "h2",
                                                            display: "h4",
                                                            title: "Rata lunara va fi de:",
                                                            classesProp: "md:inline-block text-2xl -tracking-0.5 lg:-tracking-0.54 lg:text-26px leading-none",
                                                            font: "medium"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                            as: "h2",
                                                            display: "h4",
                                                            title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "text-red-brand ml-2 md:ml-4",
                                                                children: [
                                                                    rate,
                                                                    " ",
                                                                    currency
                                                                ]
                                                            }),
                                                            classesProp: "mt-3 md:mt-0 md:inline-block text-2xl -tracking-0.5 lg:-tracking-0.54 lg:text-26px leading-none",
                                                            font: "medium"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                            className: "mt-3 md:mt-0 block text-red-brand text-[11px] leading-[14.3px]",
                                                            children: "Valoarea ratei afisata este orientativa si nu are valoare contractuala."
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                    as: "h2",
                                                    display: "h4",
                                                    title: "Momentan nu am putut calcula valoarea ratei lunare.",
                                                    classesProp: "md:inline-block text-2xl -tracking-0.5 lg:-tracking-0.54 lg:text-26px leading-none",
                                                    font: "medium"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "xl:flex xl:-mx-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "xl:w-1/2 xl:px-2 mb-4",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                            component: InputText/* default */.Z,
                                                            id: "online_credit_request_last_name",
                                                            name: "last_name",
                                                            label: "Nume",
                                                            inputClassName: "max-w-full",
                                                            labelClass: "leading-18.2",
                                                            required: true,
                                                            validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isAlphaNumeric */.bJ)(), (0,validations/* hasMinLength */.vd)(3))
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "xl:w-1/2 xl:px-2 mb-4",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                            component: InputText/* default */.Z,
                                                            id: "online_credit_request_first_name",
                                                            name: "first_name",
                                                            label: "Prenume",
                                                            inputClassName: "max-w-full",
                                                            labelClass: "leading-18.2",
                                                            required: true,
                                                            validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isAlphaNumeric */.bJ)(), (0,validations/* hasMinLength */.vd)(3))
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "xl:flex xl:-mx-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "xl:w-1/2 xl:px-2 mb-4",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                            component: InputText/* default */.Z,
                                                            id: "online_credit_request_phone",
                                                            name: "phone",
                                                            label: "Telefon",
                                                            inputClassName: "max-w-full",
                                                            labelClass: "leading-18.2",
                                                            placeholder: "Numar de telefon",
                                                            type: "tel",
                                                            required: true,
                                                            validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isPhoneNumber */.xT)())
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "xl:w-1/2 xl:px-2 mb-4",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                            component: InputText/* default */.Z,
                                                            id: "online_credit_request_email",
                                                            name: "email",
                                                            label: "Introdu adresa de email",
                                                            inputClassName: "max-w-full",
                                                            labelClass: "leading-18.2",
                                                            type: "email",
                                                            required: true,
                                                            validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isEmail */.Jh)(), (0,validations/* hasMaxLength */.aG)(80))
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mb-4",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                    name: "agree_terms",
                                                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            "Sunt de acord cu",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "".concat(baseUrl, "/suport-clienti/informatii-generale-termeni-si-conditii/"),
                                                                title: "Termenii si conditiile",
                                                                target: "_blank",
                                                                rel: "noopener noreferrer",
                                                                children: "Termenii si conditiile"
                                                            }),
                                                            " ",
                                                            "de utilizare a site-ului",
                                                            " ",
                                                            websiteName,
                                                            ".ro"
                                                        ]
                                                    }),
                                                    type: "checkbox",
                                                    component: Checkbox/* default */.Z,
                                                    required: true,
                                                    validate: (0,validations/* isRequired */.q9)()
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "lg:w-232px mx-auto mt-6 lg:mt-12",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    type: "submit",
                                                    display: "block",
                                                    variant: "primary",
                                                    title: "Vreau sa fiu contactat"
                                                })
                                            }),
                                            isSending && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
                                                height: 80,
                                                children: "Se trimite"
                                            })
                                        ]
                                    }));
                                }
                            }),
                            isSent && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "u-space-mb-20 u-text-align-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                                    type: "success",
                                    showIcon: true,
                                    children: "Formularul a fost trimis."
                                })
                            })
                        ]
                    }));
                }
                // No data available, fallback
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "u-space-p-30",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: "Calculatorul de credit este momentan indisponibil."
                    })
                }));
            }
        }
    ]);
    return OnlineCreditRequestForm;
}(react.Component);
/* harmony default export */ var FinancingSolutions_OnlineCreditRequestForm = ((0,es/* connect */.$j)(null, {
    getLoanSimulation: actions/* getLoanSimulation */.eC
})(OnlineCreditRequestForm));

// EXTERNAL MODULE: ./components/ResponsiveHeroBanner.js
var ResponsiveHeroBanner = __webpack_require__(97119);
;// CONCATENATED MODULE: ./containers/FinancingSolutions/OnlineCredit.js









var OnlineCredit_ref = (0,config["default"])(), OnlineCredit_publicRuntimeConfig = OnlineCredit_ref.publicRuntimeConfig, cdn = OnlineCredit_publicRuntimeConfig.settings.cdn;
var OnlineCredit = function(param) {
    var customer = param.customer, onFormSubmit = param.onFormSubmit, cmsBlocks = param.cmsBlocks, credexPageConfig = param.credexPageConfig, banner = param.banner;
    var ref1;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                breadcrumbs: [
                    {
                        id: 1,
                        level: 2,
                        name: "Solutii de finantare",
                        url_key: "solutii-finantare/"
                    },
                    {
                        id: 1,
                        level: 99,
                        name: "Rate online CREDEX"
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-1c3c8432f9218626" + " " + "hero-wrapper",
                /*#__PURE__*/ children: banner && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveHeroBanner/* default */.Z, {
                    banner: banner
                })
            }),
            !!(credexPageConfig === null || credexPageConfig === void 0 ? void 0 : (ref1 = credexPageConfig.creditOnline) === null || ref1 === void 0 ? void 0 : ref1.disclaimerBanner) && /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                className: "jsx-1c3c8432f9218626" + " " + "mt-3 text-sm leading-20 -tracking-0.29",
                children: credexPageConfig.creditOnline.disclaimerBanner
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                as: "h1",
                display: "h2",
                title: "Cumpara in rate, ONLINE, in 3 pasi simpli",
                classesProp: "mb-6 mt-55px hidden md:block -tracking-0.67"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-1c3c8432f9218626" + " " + "flex flex-col-reverse mb-6 lg:mb-24 md:flex-row md:-mx-6 md:items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "jsx-1c3c8432f9218626" + " " + "md:w-3/5 md:px-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "jsx-1c3c8432f9218626" + " " + "List lg:mt-4 lg:mr-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "jsx-1c3c8432f9218626" + " " + "mb-6 flex items-start md:items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "jsx-1c3c8432f9218626" + " " + "w-40px h-40px md:w-50px md:h-50px mt-1 md:mt-0 shrink-0 block mr-4 lg:mr-6 bg-indigo\n                           text-center align-middle md:leading-loose text-2xl text-white rounded-full",
                                        children: "1"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "jsx-1c3c8432f9218626" + " " + "text-sm leading-20 -tracking-0.29 lg:text-lg lg:leading-26 lg:-tracking-0.39",
                                        children: "Alege produsele dorite, adauga-le in cosul de cumparaturi, selecteaza modalitatea de plata \"Rate online Credex\" si finalizeaza comanda"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "jsx-1c3c8432f9218626" + " " + "mb-6 flex items-start md:items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "jsx-1c3c8432f9218626" + " " + "w-40px h-40px md:w-50px md:h-50px mt-1 md:mt-0 shrink-0 block mr-4 lg:mr-6 bg-indigo\n                         text-center align-middle md:leading-loose text-2xl text-white rounded-full",
                                        children: "2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "jsx-1c3c8432f9218626" + " " + "text-sm leading-20 -tracking-0.29 lg:text-lg lg:leading-26 lg:-tracking-0.39",
                                        children: "In noua pagina, completeaza datele solicitate, incarca actul de identitate si realizeaza un selfie (fotografie) conform recomandarilor primite"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "jsx-1c3c8432f9218626" + " " + "mb-6 flex items-start md:items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "jsx-1c3c8432f9218626" + " " + "w-40px h-40px md:w-50px md:h-50px mt-1 md:mt-0 shrink-0 block mr-4 lg:mr-6 bg-indigo\n                         text-center align-middle md:leading-loose text-2xl text-white rounded-full",
                                        children: "3"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "jsx-1c3c8432f9218626" + " " + "text-sm leading-20 -tracking-0.29 lg:text-lg lg:leading-26 lg:-tracking-0.39",
                                        children: "Dupa aprobare, semneaza online contractul si noi iti trimitem produsele prin curier direct la tine acasa"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-1c3c8432f9218626" + " " + "md:flex mb-6 lg:mb-16 md:flex-row md:-mx-6 md:items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-1c3c8432f9218626" + " " + "mb-6 md:mb-0 md:w-3/5 md:px-6 text-sm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-1c3c8432f9218626" + " " + "bg-newGray-light md:rounded-bl-2xl md:rounded-tr-2xl pt-6 pb-8 px-15px lg:px-16 lg:py-12 -mx-15px md:mx-0 lg:mr-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FinancingSolutions_OnlineCreditRequestForm, {
                                customer: customer,
                                onFormSubmit: onFormSubmit
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-1c3c8432f9218626" + " " + "md:w-2/5 md:pl-2 md:pr-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                as: "h2",
                                display: "h2",
                                title: "Avantajele ratelor online de la Credex:",
                                classesProp: "mb-6 lg:mb-8 -tracking-0.5 lg:-tracking-0.67"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "jsx-1c3c8432f9218626" + " " + "List",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "jsx-1c3c8432f9218626" + " " + "mb-8 lg:mb-6 flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "".concat(cdn, "/skin/frontend/altex/altex/images/credex/icon-1.png"),
                                                alt: "",
                                                className: "jsx-1c3c8432f9218626" + " " + "mr-4 w-50px h-50px md:w-60px md:h-60px"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "jsx-1c3c8432f9218626" + " " + "text-sm leading-20 -tracking-0.29 lg:text-lg lg:leading-26 lg:-tracking-0.39",
                                                children: "Proces 100% online"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "jsx-1c3c8432f9218626" + " " + "mb-8 lg:mb-6 flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "".concat(cdn, "/skin/frontend/altex/altex/images/credex/icon-3.png"),
                                                alt: "",
                                                className: "jsx-1c3c8432f9218626" + " " + "mr-4 w-50px h-50px md:w-60px md:h-60px"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "jsx-1c3c8432f9218626" + " " + "text-sm leading-20 -tracking-0.29 lg:text-lg lg:leading-26 lg:-tracking-0.39",
                                                children: "Raspuns rapid disponibil 24h / 7"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "jsx-1c3c8432f9218626" + " " + "mb-8 lg:mb-6 flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "".concat(cdn, "/skin/frontend/altex/altex/images/credex/icon-2.png"),
                                                alt: "",
                                                className: "jsx-1c3c8432f9218626" + " " + "mr-4 w-50px h-50px md:w-60px md:h-60px"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "jsx-1c3c8432f9218626" + " " + "text-sm leading-20 -tracking-0.29 lg:text-lg lg:leading-26 lg:-tracking-0.39",
                                                children: "Semnarea online a contractului"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "jsx-1c3c8432f9218626" + " " + "mb-8 lg:mb-6 flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "".concat(cdn, "/skin/frontend/altex/altex/images/credex/icon-4.png"),
                                                alt: "",
                                                className: "jsx-1c3c8432f9218626" + " " + "mr-4 w-50px h-50px md:w-60px md:h-60px"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "jsx-1c3c8432f9218626" + " " + "text-sm leading-20 -tracking-0.29 lg:text-lg lg:leading-26 lg:-tracking-0.39",
                                                children: "Fara deplasari la magazin sau banca"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-1c3c8432f9218626" + " " + "md:flex md:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-1c3c8432f9218626" + " " + "mb-6 md:mb-0 grow md:pr-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                as: "h2",
                                display: "h2",
                                title: "Conditii de eligibilitate:",
                                classesProp: "mt-6 mb-2 lg:my-6 -tracking-0.5 lg:-tracking-0.67"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "jsx-1c3c8432f9218626" + " " + "list-disc ml-5 text-sm md:text-base -tracking-0.29 lg:-tracking-0.33",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "jsx-1c3c8432f9218626" + " " + "u-space-mb-10",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "jsx-1c3c8432f9218626",
                                            children: "Cetateni romani cu domiciliul in Romania"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "jsx-1c3c8432f9218626" + " " + "u-space-mb-10",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "jsx-1c3c8432f9218626",
                                            children: "Varsta cuprinsa intre 18 si 70 de ani"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "jsx-1c3c8432f9218626" + " " + "u-space-mb-10",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "jsx-1c3c8432f9218626",
                                            children: "Vechimea la actualul loc de munca de 3 luni neintrerupte"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "jsx-1c3c8432f9218626" + " " + "u-space-mb-10",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "jsx-1c3c8432f9218626",
                                            children: "Valoare credit: 300 - 30.000 lei"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "jsx-1c3c8432f9218626" + " " + "u-space-mb-10",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "jsx-1c3c8432f9218626",
                                            children: "Perioada de creditare 6-59 luni"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "jsx-1c3c8432f9218626" + " " + "u-space-mb-10",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "jsx-1c3c8432f9218626",
                                                children: "Venitul minim acceptat:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                className: "jsx-1c3c8432f9218626" + " " + "list-inside list-none ml-4 leading-30",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "jsx-1c3c8432f9218626",
                                                        children: "- Angajati: 1.200 lei"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "jsx-1c3c8432f9218626",
                                                        children: "- Pensionari: 800 lei"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-1c3c8432f9218626" + " " + "md:w-380px md:pl-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                as: "h2",
                                display: "h2",
                                title: "Documente necesare:",
                                classesProp: "my-6 -tracking-0.5 lg:-tracking-0.67"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "jsx-1c3c8432f9218626" + " " + "list-disc ml-5 text-sm md:text-base -tracking-0.29 lg:-tracking-0.33",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "jsx-1c3c8432f9218626" + " " + "u-space-mb-10",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "jsx-1c3c8432f9218626",
                                            children: "Carte de identitate in original"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "jsx-1c3c8432f9218626" + " " + "u-space-mb-10",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "jsx-1c3c8432f9218626",
                                            children: "Talon de pensie (in cazul pensionarilor)"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            cmsBlocks["solutii-finantare_credit-online_txt"] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: cmsBlocks["solutii-finantare_credit-online_txt"]
                },
                className: "jsx-1c3c8432f9218626"
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "1c3c8432f9218626",
                children: ".hero-wrapper img{width:100%;\nborder-bottom-left-radius:1rem;\nborder-top-right-radius:1rem}"
            })
        ]
    }));
};
OnlineCredit.propTypes = {
    customer: prop_types_default().shape({
        first_name: (prop_types_default()).string,
        last_name: (prop_types_default()).string,
        email: (prop_types_default()).string
    }),
    onFormSubmit: (prop_types_default()).func.isRequired
};
/* harmony default export */ var FinancingSolutions_OnlineCredit = (OnlineCredit);

// EXTERNAL MODULE: ./containers/ErrorPage.js
var ErrorPage = __webpack_require__(75720);
// EXTERNAL MODULE: ./store/app/actions.js
var app_actions = __webpack_require__(27173);
// EXTERNAL MODULE: ./lib/api/helpers.js
var helpers = __webpack_require__(45963);
// EXTERNAL MODULE: ./lib/api/index.js
var api = __webpack_require__(2642);
// EXTERNAL MODULE: ./lib/transformV2Banners.js
var transformV2Banners = __webpack_require__(6100);
;// CONCATENATED MODULE: ./pages/solutii-finantare/credit-online.js














function credit_online_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function credit_online_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function credit_online_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                credit_online_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                credit_online_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function credit_online_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function credit_online_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function credit_online_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) credit_online_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) credit_online_defineProperties(Constructor, staticProps);
    return Constructor;
}
function credit_online_getPrototypeOf(o) {
    credit_online_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return credit_online_getPrototypeOf(o);
}
function credit_online_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) credit_online_setPrototypeOf(subClass, superClass);
}
function credit_online_possibleConstructorReturn(self, call) {
    if (call && (credit_online_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return credit_online_assertThisInitialized(self);
}
function credit_online_setPrototypeOf(o, p) {
    credit_online_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return credit_online_setPrototypeOf(o, p);
}
var credit_online_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function credit_online_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function credit_online_createSuper(Derived) {
    var hasNativeReflectConstruct = credit_online_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = credit_online_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = credit_online_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return credit_online_possibleConstructorReturn(this, result);
    };
}
var credit_online_ref = (0,config["default"])(), credit_online_publicRuntimeConfig = credit_online_ref.publicRuntimeConfig, credit_online_credex = credit_online_publicRuntimeConfig.credex, settings = credit_online_publicRuntimeConfig.settings;
// TODO banner id for brico
var BANNER_ID = settings.websiteName === "altex" ? 47 : 48;
var credit_online_OnlineCredit = /*#__PURE__*/ function(Component1) {
    "use strict";
    credit_online_inherits(OnlineCredit, Component1);
    var _super = credit_online_createSuper(OnlineCredit);
    function OnlineCredit() {
        credit_online_classCallCheck(this, OnlineCredit);
        return _super.apply(this, arguments);
    }
    credit_online_createClass(OnlineCredit, [
        {
            key: "render",
            /*#__PURE__*/ value: function render() {
                var _props = this.props, customer = _props.customer, submitOnlineCreditRequest1 = _props.submitOnlineCreditRequest, credexPageConfig = _props.credexPageConfig, banner = _props.banner;
                if (credit_online_credex.isEnabled) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                    children: "Credit online"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FinancingSolutions_OnlineCredit, {
                                customer: customer,
                                onFormSubmit: submitOnlineCreditRequest1,
                                cmsBlocks: this.props.cmsBlocks,
                                credexPageConfig: credexPageConfig,
                                banner: banner
                            })
                        ]
                    }));
                }
                // Store data incomplete
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* default */.Z, {
                    children: "Pagina este indisponibila temporar."
                }));
            }
        }
    ], [
        {
            key: "getInitialProps",
            value: function getInitialProps(ctx) {
                return credit_online_asyncToGenerator(runtime_default().mark(function _callee() {
                    var reduxStore, credexPageConfig, banner;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                reduxStore = ctx.reduxStore;
                                _ctx.next = 3;
                                return reduxStore.dispatch((0,app_actions/* getCmsBlocks */.lD)([
                                    "solutii-finantare_credit-online_txt"
                                ]));
                            case 3:
                                credexPageConfig = reduxStore.getState().credex.page;
                                if (credexPageConfig) {
                                    _ctx.next = 7;
                                    break;
                                }
                                _ctx.next = 7;
                                return reduxStore.dispatch((0,credex_actions/* getCredexPageConfig */.Y)());
                            case 7:
                                _ctx.next = 9;
                                return (0,helpers/* makeApiCall */.Vo)({
                                    apiCall: api/* getBannersV2Api */.a5o,
                                    apiArgs: [
                                        {
                                            id: BANNER_ID
                                        }
                                    ],
                                    formatResponse: function(response) {
                                        return response.data;
                                    },
                                    returnResponse: true
                                });
                            case 9:
                                banner = _ctx.sent;
                                return _ctx.abrupt("return", banner ? {
                                    banner: (0,transformV2Banners/* default */.Z)(banner)
                                } : null);
                            case 11:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        }
    ]);
    return OnlineCredit;
}(react.Component);
credit_online_OnlineCredit.pageLayout = "default";
/* harmony default export */ var credit_online = ((0,es/* connect */.$j)(function(state) {
    return {
        cmsBlocks: state.app.cmsBlocks,
        customer: state.user.customer,
        credexPageConfig: state.credex.page
    };
}, {
    submitOnlineCreditRequest: actions/* submitOnlineCreditRequest */.KP
})(credit_online_OnlineCredit));


/***/ }),

/***/ 82518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "eC": function() { return /* binding */ getLoanSimulation; },
  "_C": function() { return /* binding */ submitInStoreCreditRequest; },
  "KP": function() { return /* binding */ submitOnlineCreditRequest; }
});

;// CONCATENATED MODULE: ./store/financing-solutions/constants.js
var SUBMIT_IN_STORE_CREDIT_REQUEST = "FINANCING-SOLUTIONS/SUBMIT_IN_STORE_CREDIT_REQUEST";
var SUBMIT_IN_STORE_CREDIT_REQUEST_SUCCESS = "FINANCING-SOLUTIONS/SUBMIT_IN_STORE_CREDIT_REQUEST_SUCCESS";
var SUBMIT_IN_STORE_CREDIT_REQUEST_FAILURE = "FINANCING-SOLUTIONS/SUBMIT_IN_STORE_CREDIT_REQUEST_FAILURE";
var SUBMIT_ONLINE_CREDIT_REQUEST = "FINANCING-SOLUTIONS/SUBMIT_ONLINE_CREDIT_REQUEST";
var SUBMIT_ONLINE_CREDIT_REQUEST_SUCCESS = "FINANCING-SOLUTIONS/SUBMIT_ONLINE_CREDIT_REQUEST_SUCCESS";
var SUBMIT_ONLINE_CREDIT_REQUEST_FAILURE = "FINANCING-SOLUTIONS/SUBMIT_ONLINE_CREDIT_REQUEST_FAILURE";
var GET_LOAN_SIMULATION = "FINANCING-SOLUTIONS/GET_LOAN_SIMULATION";
var GET_LOAN_SIMULATION_SUCCESS = "FINANCING-SOLUTIONS/GET_LOAN_SIMULATION_SUCCESS";
var GET_LOAN_SIMULATION_FAILURE = "FINANCING-SOLUTIONS/GET_LOAN_SIMULATION_FAILURE";

// EXTERNAL MODULE: ./lib/api/helpers.js
var helpers = __webpack_require__(45963);
// EXTERNAL MODULE: ./lib/api/index.js
var api = __webpack_require__(2642);
;// CONCATENATED MODULE: ./store/financing-solutions/actions.js



var submitInStoreCreditRequest = function(values) {
    return function(dispatch, getState) {
        return (0,helpers/* makeApiCall */.Vo)({
            actions: {
                action: SUBMIT_IN_STORE_CREDIT_REQUEST,
                success: SUBMIT_IN_STORE_CREDIT_REQUEST_SUCCESS,
                fail: SUBMIT_IN_STORE_CREDIT_REQUEST_FAILURE
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            spinnerMessage: "Se trimite cererea...",
            alert: true,
            alertMessage: "Error sending request",
            apiCall: api/* submitInStoreCreditRequestApi */.J0i,
            apiArgs: [
                values
            ],
            formatResponse: function(response) {
                return response.data;
            },
            returnResponse: true
        });
    };
};
var submitOnlineCreditRequest = function(values) {
    return function(dispatch, getState) {
        return (0,helpers/* makeApiCall */.Vo)({
            actions: {
                action: SUBMIT_ONLINE_CREDIT_REQUEST,
                success: SUBMIT_ONLINE_CREDIT_REQUEST_SUCCESS,
                fail: SUBMIT_ONLINE_CREDIT_REQUEST_FAILURE
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            spinnerMessage: "Se trimite cererea...",
            alert: true,
            alertMessage: "Eroare la trimiterea solicitarii",
            apiCall: api/* submitOnlineCreditRequestApi */.rFX,
            apiArgs: [
                values
            ],
            formatResponse: function(response) {
                return response.data;
            },
            returnResponse: true
        });
    };
};
var getLoanSimulation = function(values) {
    return function(dispatch, getState) {
        return (0,helpers/* makeApiCall */.Vo)({
            actions: {
                action: GET_LOAN_SIMULATION,
                success: GET_LOAN_SIMULATION_SUCCESS,
                fail: GET_LOAN_SIMULATION_FAILURE
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            spinnerMessage: "Se trimite cererea...",
            alert: false,
            alertMessage: "Eroare la trimiterea solicitarii",
            apiCall: api/* getLoanSimulationApi */.caK,
            apiArgs: [
                values
            ],
            formatResponse: function(response) {
                return response.data;
            },
            returnResponse: true
        });
    };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(40570); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);